import {
  ClearStoreAction,
  DownloadTemplateRequestAction,
  DownloadTemplateSettledAction,
  LoadEngineErrorAction,
  LoadEngineRequestAction,
  LoadEngineSuccessAction,
  LoadVersionErrorAction,
  LoadVersionRequestAction,
  LoadVersionSuccessAction,
} from './actions.d';
import actionTypes from './actionTypes';
import {
  IDownloadTemplateRequestPayload,
  ILoadEngineRequestPayload,
  ILoadEngineSuccessPayload,
  ILoadVersionRequestPayload,
  ILoadVersionSuccessPayload,
} from './types';

const actions = {
  loadEngineRequest: (payload: ILoadEngineRequestPayload): LoadEngineRequestAction => ({
    type: actionTypes.LOAD_ENGINE_REQUEST,
    payload,
  }),

  loadEngineSuccess: (payload: ILoadEngineSuccessPayload): LoadEngineSuccessAction => ({
    type: actionTypes.LOAD_ENGINE_SUCCESS,
    payload,
  }),

  loadEngineError: (): LoadEngineErrorAction => ({
    type: actionTypes.LOAD_ENGINE_ERROR,
  }),

  loadVersionRequest: (payload: ILoadVersionRequestPayload): LoadVersionRequestAction => ({
    type: actionTypes.LOAD_VERSION_REQUEST,
    payload,
  }),

  loadVersionSuccess: (payload: ILoadVersionSuccessPayload): LoadVersionSuccessAction => ({
    type: actionTypes.LOAD_VERSION_SUCCESS,
    payload,
  }),

  loadVersionError: (): LoadVersionErrorAction => ({
    type: actionTypes.LOAD_VERSION_ERROR,
  }),

  downloadTemplateRequest: (payload: IDownloadTemplateRequestPayload): DownloadTemplateRequestAction => ({
    type: actionTypes.DOWNLOAD_TEMPLATE_REQUEST,
    payload,
  }),

  downloadTemplateSettled: (payload: IDownloadTemplateRequestPayload): DownloadTemplateSettledAction => ({
    type: actionTypes.DOWNLOAD_TEMPLATE_SETTLED,
    payload,
  }),

  clearStore: (): ClearStoreAction => ({
    type: actionTypes.CLEAR_STORE,
  }),
};

export default actions;
